import {
    ActionComponentCreateProps,
} from 'app/shared-components/SkyNetDomain/SkyNetDomain.types'
import requests from 'app/requests/FreightForwarder.request'

import FreightForwarderForm from '../FreightForwarderForm'

const FreightForwarderCreate = ({
    onSuccess,
}: ActionComponentCreateProps) => {
    return (
        <FreightForwarderForm
            request={requests.create()}
            onSuccess={onSuccess}
        />
    )
}

export default FreightForwarderCreate
